export default __webpack_public_path__ + "static/media/topic7.567d0e36.png";